<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DYPhJo/tc-custom/9781637968253.jpg?1693338706552" alt="This image is the cover for the book Something is Killing the Children Pen & Ink #1, Something is Killing the Children Pen & Ink"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Something is Killing the Children Pen & Ink #1, Something is Killing the Children Pen & Ink
      </h1>
      <p class="bookDescription body article font2">
        <p>BOOM! Studios is proud to present PEN &amp; INK, a deluxe art-focused format featuring stunning black and white interior inks with artist commentary. Begin your collection with this premium reformat of Something is Killing the Children #1, celebrating the start of Erica Slaughter’s epic journey with exclusive notes and annotations from artist and co-creator Werther Dell'Edera. This issue will be available with a premium cardstock cover, alongside a gorgeous Spot UV variant cover and a blank sketch cover.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Tynion IV, Werther Dell’Edera
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b0b95284